import { writeCrossTabCatalogModeBusy } from 'pages/Robot/RobotView/RobotLeftBlock/Service/catalogServiceCrossTab'
import { serviceModeActionKey } from 'pages/Robot/RobotView/RobotLeftBlock/Service/serviceModeActionKeys'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RobotActions } from 'store/actions/robot'
import { selectRobotActiveMode } from 'store/selectors/robot'
import { ROBOT_MODES } from 'utils/constants'
import { IModeSwitchPending, RootState } from 'utils/interfaces'

function isServiceTabDispatchSettled(
  optimistic: RootState['robot']['serviceModeSwitchOptimistic'],
  activeMode: ROBOT_MODES | null | undefined,
  serverPending: IModeSwitchPending | null | undefined
): boolean {
  if (!optimistic?.actionKey.startsWith('tab:')) {
    return true
  }
  return !serverPending && activeMode !== optimistic.mode
}

/** Loading/spinner for non-catalog service-tab mode switches (mapping, localization, legacy tasks). */
export function useServiceTabActionLoading() {
  const dispatch = useDispatch()
  const activeMode = useSelector(selectRobotActiveMode)
  const optimistic = useSelector((state: RootState) => state.robot.serviceModeSwitchOptimistic)
  const serverPending = useSelector((state: RootState) => state.robot.robotInfo?.modeSwitchPending)
  const robotId = useSelector((state: RootState) => state.robot.robotInfo?.id)

  const isTabActionInFlight = (actionKey: string | undefined) => {
    if (!optimistic || !actionKey || optimistic.actionKey !== actionKey) {
      return false
    }
    return !isServiceTabDispatchSettled(optimistic, activeMode, serverPending)
  }

  const isTabActionLoading = (id: string) =>
    isTabActionInFlight(serviceModeActionKey.tab(id)) || isTabActionInFlight(serviceModeActionKey.tab(`${id}-stop`))

  const isTabActionLoadingOnly = (id: string) => isTabActionInFlight(serviceModeActionKey.tab(id))

  useEffect(() => {
    if (!optimistic?.actionKey.startsWith('tab:')) {
      return
    }
    if (!isServiceTabDispatchSettled(optimistic, activeMode, serverPending)) {
      return
    }
    if (robotId) {
      writeCrossTabCatalogModeBusy(robotId, null)
    }
    dispatch(RobotActions.clearServiceModeSwitchOptimistic())
  }, [activeMode, dispatch, optimistic, robotId, serverPending])

  return { isTabActionLoading, isTabActionLoadingOnly }
}
